/**
 * Determine whether a timeline event starts a new visual group.
 * A group starts when the user changes compared to the previous event.
 */
export function isUserGroupStart(
  currentUserId: number,
  prevUserId: number | null | undefined,
): boolean {
  return prevUserId == null || prevUserId !== currentUserId;
}
